import { ChartOptions, Plugin } from 'chart.js';

export const CLineChartPlugins: Plugin<'line'> = {
  id: 'LineWithLine',
  afterDraw: chart => {
    const activeEle = chart.getActiveElements();
    if (activeEle.length <= 0) return;
    const { ctx, scales } = chart;
    const { x } = activeEle[0].element;
    const topY = scales.y.top;
    const bottomY = scales.y.bottom;
    // draw vertical line
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(x, topY);
    ctx.lineTo(x, bottomY);
    ctx.lineWidth = 1.5;
    ctx.setLineDash([8, 8]);
    ctx.strokeStyle = '#21917F';
    ctx.stroke();
    ctx.restore();
  },
};

export const CLineChartOptions: ChartOptions<'line'> = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index' as const,
    intersect: false,
  },
  plugins: {
    title: {
      display: false,
      text: 'Chart.js Line Chart - Multi Axis',
    },
    legend: {
      display: false
    },
    tooltip: {
      mode: 'index',
      intersect: false,
      callbacks: {
        title: (tooltipItems: any[]): string | string[] | void => {
          return tooltipItems.map(tooltip => `$${ tooltip.raw }`)
        },
        label: (): string | string[] | void => '',
      },
      backgroundColor: '#21917F',
      titleMarginBottom: 0,
      padding: 7,
      animation: false,
      titleFont: {
        family: 'Noto Sans',
        weight: 'normal',
        size: 12,
      },
      // xAlign: 'center',
      // yAlign: 'bottom',
    },
  },
  scales: {
    y: {
      display: true,
      position: 'left' as const,
      beginAtZero: true,
      border: {
        dash: [5, 5]
      },
      ticks: {
        callback: (label) => {
          let numValue: number | string = Number(label);
          if (numValue > 1000) {
            numValue = (numValue / 1000) + 'K'
          }
          return `$${ numValue }`;
        }
      },
    },
    x: {
      border: {
        dash: [5, 5]
      }
    },
  },
};

export const CLineDatasetDefaultOptions = {
  backgroundColor: 'white',
  yAxisID: 'y',
  tension: 0.2,
  pointRadius: 3,
  pointBorderWidth: 2,
  pointHoverRadius: 3,
  pointHoverBorderWidth: 2,
  pointHoverBackgroundColor: 'white',
  showLine: true,
}
